<template>
  <v-container>
    <v-tabs centered>
      <v-tab> Warehouse KPI </v-tab>
      <v-tab> Seller Experience KPI </v-tab>
      <v-tab> Custom KPI </v-tab>

      <!-------------------------WAREHOUSE KPI----------------------------->
      <v-tab-item>
        <br />
        <h3 class="basic--text">Registrations</h3>
        <v-data-table
          dense
          :headers="headersStats"
          :items="overallKpisWarehouse"
          hide-default-footer
          disable-pagination
          class="elevation-1"
          :loading="loadingWarehouse"
          loading-text="Loading data... Please wait..."
        ></v-data-table>

        <h3 class="basic--text mt-3">Totals by person</h3>
        <v-data-table
          dense
          :headers="personHeadersW"
          :items="personKpisWarehouse"
          hide-default-footer
          disable-pagination
          class="elevation-1"
          :loading="loadingWarehouse"
          loading-text="Loading data... Please wait..."
        ></v-data-table>
        <v-row class="mt-4">
          <v-col cols="6">
            <h3 class="basic--text">Full</h3>
            <GChart
              type="ColumnChart"
              :data="chartDataWarehouseFull"
              :options="$vuetify.theme.dark ? darkOptions : lightOptions"
            />
          </v-col>
          <v-col cols="6">
            <h3 class="basic--text">Quick</h3>
            <GChart
              type="ColumnChart"
              :data="chartDataWarehouseQuick"
              :options="$vuetify.theme.dark ? darkOptions : lightOptions"
            />
          </v-col>
        </v-row>
      </v-tab-item>
      <!-------------------------------------------------------------------->

      <!-------------------------SELLER EXPIERENCE KPI--------------------->
      <v-tab-item>
        <h3 class="basic--text">Descriptions</h3>
        <v-data-table
          dense
          :headers="headersStats"
          :items="overallKpisSEStats"
          hide-default-footer
          disable-pagination
          class="elevation-1"
          :loading="loadingSE"
          loading-text="Loading data... Please wait..."
        ></v-data-table>

        <!-- <h3 class="basic--text">Description modifications</h3>
        <v-data-table
          dense
          :headers="headers"
          :items="modificationsKpisSE"
          hide-default-footer
          disable-pagination
          class="elevation-1"
          :loading="loadingSE"
          loading-text="Loading data... Please wait..."
        ></v-data-table> -->

        <h3 class="basic--text mt-4">Totals by person</h3>
        <v-data-table
          dense
          :headers="personHeadersSE"
          :items="personKpisSE"
          hide-default-footer
          disable-pagination
          class="elevation-1"
          :loading="loadingSE"
          loading-text="Loading data... Please wait..."
        ></v-data-table>
        <v-row class="my-6">
          <v-col cols="12">
            <h3 class="basic--text">Re-registrations</h3>
            <v-data-table
              dense
              :headers="headersReRegistration"
              :items="personReRegistrations"
              hide-default-footer
              disable-pagination
              class="elevation-1"
              :loading="loadingSE"
              loading-text="Loading data... Please wait..."
            ></v-data-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <h3 class="basic--text">Full</h3>
            <GChart
              type="ColumnChart"
              :data="chartDataSEFull"
              :options="$vuetify.theme.dark ? darkOptions : lightOptions"
            />
          </v-col>
          <v-col cols="6">
            <h3 class="basic--text">Quick</h3>
            <GChart
              type="ColumnChart"
              :data="chartDataSEQuick"
              :options="$vuetify.theme.dark ? darkOptions : lightOptions"
            />
          </v-col>
        </v-row>
      </v-tab-item>
      <!-------------------------------------------------------------------->

      <!------------------------------CUSTOM KPI---------------------------->
      <v-tab-item>
        <v-form>
          <v-row>
            <v-col cols="12" sm="3">
              <v-menu
                v-model="menuStart"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDate"
                    label="Start date"
                    prepend-icon="mdi-calendar-month-outline"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  @input="menuStart = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <v-menu
                v-model="menuEnd"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="endDate"
                    label="End date"
                    prepend-icon="mdi-calendar-month-outline"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  @input="menuEnd = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
        <v-btn color="teal" outlined @click="getCustomData">
          Get data
          <v-icon right>mdi-calendar-start</v-icon></v-btn
        >
        <br />
        <br />
        <v-divider></v-divider>
        <br />
        <br />
        <h2 class="basic--text">Warehouse</h2>
        <h3 class="basic--text">Total registrations</h3>
        <v-data-table
          dense
          :headers="headersStatsCustomW"
          :items="KPIWarehouseStatsCustom"
          hide-default-footer
          disable-pagination
          class="elevation-1"
          :loading="loadingCustom"
          loading-text="Loading data... Please wait..."
        ></v-data-table>
        <br />
        <v-divider></v-divider>
        <br />
        <h3 class="basic--text">Totals by person</h3>

        <v-row>
          <v-col cols="12">
            <v-data-table
              dense
              :headers="personHeadersCustomWarehouse"
              :items="personKpisWarehouseCustom"
              hide-default-footer
              disable-pagination
              class="elevation-1"
              :loading="loadingCustom"
              loading-text="Loading data... Please wait..."
            ></v-data-table>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <h3 class="basic--text">Full</h3>
            <GChart
              type="ColumnChart"
              :data="chartDataWarehouseCustomFull"
              :options="$vuetify.theme.dark ? darkOptions : lightOptions"
            />
          </v-col>
          <v-col cols="6">
            <h3 class="basic--text">Quick</h3>
            <GChart
              type="ColumnChart"
              :data="chartDataWarehouseCustomQuick"
              :options="$vuetify.theme.dark ? darkOptions : lightOptions"
            />
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <br />
        <h2 class="basic--text">Seller experience</h2>
        <br />
        <h3 class="basic--text">Total descriptions</h3>
        <v-data-table
          dense
          :headers="headersStatsCustomSE"
          :items="overallKpisSEStatsCustom"
          hide-default-footer
          disable-pagination
          class="elevation-1"
          :loading="loadingCustom"
        ></v-data-table>
        <br />
        <h3 class="basic--text">Totals by person</h3>
        <v-row>
          <v-col cols="12">
            <v-data-table
              dense
              :headers="personHeadersCustomSE"
              :items="personKpisSECustom"
              hide-default-footer
              disable-pagination
              class="elevation-1"
              :loading="loadingCustom"
              loading-text="Loading data... Please wait..."
            ></v-data-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <h3 class="basic--text">Full</h3>
            <GChart
              type="ColumnChart"
              :data="chartDataSECustomFull"
              :options="$vuetify.theme.dark ? darkOptions : lightOptions"
            />
          </v-col>
          <v-col cols="6">
            <h3 class="basic--text">Quick</h3>
            <GChart
              type="ColumnChart"
              :data="chartDataSECustomQuick"
              :options="$vuetify.theme.dark ? darkOptions : lightOptions"
            />
          </v-col>
        </v-row>
      </v-tab-item>
      <!-------------------------------------------------------------------->
    </v-tabs>
  </v-container>
</template>

<script>
import { GChart } from "vue-google-charts";
import moment from "moment";
moment().format();

export default {
  name: "KPI",
  components: {
    GChart,
  },
  data: () => ({
    darkOptions: {
      backgroundColor: "#000000",
      titleTextStyle: {
        color: "#FFFFFF",
      },
      hAxis: {
        textStyle: {
          color: "#FFFFFF",
        },
        titleTextStyle: {
          color: "#FFFFFF",
        },
      },
      vAxis: {
        textStyle: {
          color: "#FFFFFF",
        },
        titleTextStyle: {
          color: "#FFFFFF",
        },
      },
      legend: {
        textStyle: {
          color: "#FFFFFF",
        },
        position: "bottom",
      },
    },
    lightOptions: {
      legend: {
        position: "bottom",
      },
    },
    menuStart: false,
    menuEnd: false,
    startDate: new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    picker: new Date().toISOString().substr(0, 10),
    chartDataSEFull: [],
    chartDataSEQuick: [],
    chartDataWarehouseFull: [],
    chartDataWarehouseQuick: [],
    headers: [
      { text: "Total today", value: "today", class: "footer" },
      { text: "Total this week", value: "week", class: "footer" },
      { text: "Total this month", value: "month", class: "footer" },
      { text: "Total this quarter", value: "quarter", class: "footer" },
    ],
    headersStats: [
      { text: "Median this month", value: "monthMedian", class: "footer" },
      { text: "Average this month", value: "monthAverage", class: "footer" },
      {
        text: "Total this month full/quick",
        value: "totalMonth",
        class: "footer",
      },
      {
        text: "Total this quarter full/quick",
        value: "totalQuarter",
        class: "footer",
      },
    ],
    headersStatsCustomW: [
      { text: "Median this period", value: "median", class: "footer" },
      { text: "Average this period", value: "average", class: "footer" },
      { text: "Total this period full/quick", value: "total", class: "footer" },
    ],
    headersStatsCustomSE: [
      { text: "Median this period", value: "median", class: "footer" },
      { text: "Average this period", value: "average", class: "footer" },
      { text: "Total this period full/quick", value: "total", class: "footer" },
      {
        text: "Total re-registrations this period",
        value: "reReg",
        class: "footer",
      },
    ],
    headersReRegistration: [
      { text: "Name", value: "name", class: "footer" },
      { text: "Total today", value: "today", class: "footer" },
      { text: "Total this week", value: "week", class: "footer" },
      { text: "Total this month", value: "month", class: "footer" },
      { text: "Total this quarter", value: "quarter", class: "footer" },
    ],
    personReRegistrations: [],
    overallKpisWarehouse: [],
    KPIWarehouseStatsCustom: [],
    overallKpisSEStatsCustom: [],
    // modificationsKpisSE: [],
    overallKpisSEStats: [],
    personHeadersW: [
      { text: "Name", value: "name", class: "footer" },
      { text: "Today full/quick", value: "today", class: "footer" },
      { text: "This week full/quick", value: "week", class: "footer" },
      { text: "This month full/quick", value: "month", class: "footer" },
      { text: "This quarter full/quick", value: "quarter", class: "footer" },
    ],
    personHeadersSE: [
      { text: "Name", value: "name", class: "footer" },
      {
        text: "Today full/quick/modifications",
        value: "today",
        class: "footer",
      },
      {
        text: "This week full/quick/modifications",
        value: "week",
        class: "footer",
      },
      {
        text: "This month full/quick/modifications",
        value: "month",
        class: "footer",
      },
      {
        text: "This quarter full/quick/modifications",
        value: "quarter",
        class: "footer",
      },
    ],
    personHeadersCustomWarehouse: [
      { text: "Name", value: "name", class: "footer" },
      { text: "Full/quick", value: "quantity", class: "footer" },
    ],
    personHeadersCustomSE: [
      { text: "Name", value: "name", class: "footer" },
      { text: "Full/quick", value: "quantity", class: "footer" },
      { text: "Modifications", value: "modifications", class: "footer" },
      { text: "Re-registrations", value: "reReg", class: "footer" },
    ],
    personKpisWarehouse: [],
    personKpisSE: [],
    personKpisSECustom: [],
    loadingWarehouse: false,
    loadingSE: false,
    loadingCustom: false,
    personKpisWarehouseCustomQuick: [],
    personKpisWarehouseCustomFull: [],
    personKpisSECustomFull: [],
    personKpisSECustomQuick: [],
    personKpisSECustomMod: [],
    personKpisWarehouseCustom: [],
    chartDataWarehouseCustomFull: [],
    chartDataWarehouseCustomQuick: [],
    chartDataSECustomFull: [],
    chartDataSECustomQuick: [],
  }),
  computed: {},
  methods: {
    async getData() {
      this.loadingWarehouse = true;
      this.loadingSE = true;

      let data = await this.formatIntervals();

      try {
        const response = await this.$store.dispatch("getKPI", data);
        let results = response.data;

        this.overallKpisWarehouse = [
          {
            monthMedian: results.month.warehouse.stats.median,
            monthAverage: results.month.warehouse.stats.average,
            totalMonth: `${results.month.warehouse.stats.totalFull}/${results.month.warehouse.stats.totalQuick}`,
            totalQuarter: `${results.quarter.warehouse.stats.totalFull}/${results.quarter.warehouse.stats.totalQuick}`,
          },
        ];

        this.overallKpisSEStats = [
          {
            monthMedian: results.month.sellerExperience.stats.median,
            monthAverage: results.month.sellerExperience.stats.average,
            totalMonth: `${results.month.sellerExperience.stats.fullTotal}/${results.month.sellerExperience.stats.quickTotal}`,
            totalQuarter: `${results.quarter.sellerExperience.stats.fullTotal}/${results.quarter.sellerExperience.stats.quickTotal}`,
          },
        ];

        this.personKpisWarehouse = await this.formatPersonKpis(
          results,
          "warehouse"
        );
        this.personKpisSE = await this.formatPersonKpis(
          results,
          "sellerExperience"
        );

        if (this.personKpisWarehouse.length > 0) {
          this.chartDataWarehouseFull = this.formatChartKpis(
            this.personKpisWarehouse,
            0
          );
          this.chartDataWarehouseQuick = this.formatChartKpis(
            this.personKpisWarehouse,
            1
          );
        }

        if (this.personKpisSE.length > 0) {
          this.chartDataSEFull = this.formatChartKpis(this.personKpisSE, 0);
          this.chartDataSEQuick = this.formatChartKpis(this.personKpisSE, 1);
        }

        this.personReRegistrations = await this.formatReRegistrations(results);

        this.loadingWarehouse = false;
        this.loadingSE = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getCustomData() {
      this.loadingCustom = true;

      let custom = [this.startDate, this.endDate, "custom"];

      try {
        const response = await this.$store.dispatch("getKPI", [custom]);
        let results = response.data;

        this.KPIWarehouseStatsCustom = [
          {
            median: results.custom.warehouse.stats.median,
            average: results.custom.warehouse.stats.average,
            total: `${results.custom.warehouse.stats.totalFull}/${results.custom.warehouse.stats.totalQuick}`,
          },
        ];

        this.overallKpisSEStatsCustom = [
          {
            median: results.custom.sellerExperience.stats.median,
            average: results.custom.sellerExperience.stats.average,
            total: `${results.custom.sellerExperience.stats.fullTotal}/${results.custom.sellerExperience.stats.quickTotal}`,
            reReg: results.custom.sellerExperience.stats.reRegTotal,
          },
        ];

        this.personKpisWarehouseCustom = await this.formatPersonKpisCustom(
          results,
          "warehouse"
        );

        this.personKpisSECustom = await this.formatPersonKpisCustom(
          results,
          "sellerExperience"
        );

        this.chartDataWarehouseCustomFull = this.formatChartKpisCustom(
          this.personKpisWarehouseCustom,
          0
        );

        this.chartDataWarehouseCustomQuick = this.formatChartKpisCustom(
          this.personKpisWarehouseCustom,
          1
        );

        this.chartDataSECustomFull = this.formatChartKpisCustom(
          this.personKpisSECustom,
          0
        );
        this.chartDataSECustomQuick = this.formatChartKpisCustom(
          this.personKpisSECustom,
          1
        );

        this.loadingCustom = false;
      } catch (error) {
        console.log(error);
      }
    },
    async formatIntervals() {
      let today = new Date(moment().format("YYYY-M-D"));
      let startWeek = new Date(moment().startOf("week").format("YYYY-M-D"));
      let endWeek = new Date(moment().endOf("week").format("YYYY-M-D"));
      let startMonth = new Date(moment().startOf("month").format("YYYY-M-D"));
      let endMonth = new Date(moment().endOf("month").format("YYYY-M-D"));
      let startQuarter = new Date(
        moment().startOf("quarter").format("YYYY-M-D")
      );
      let endQuarter = new Date(moment().endOf("quarter").format("YYYY-M-D"));
      let todayInterval = [today, today, "today"];
      let weekInterval = [startWeek, endWeek, "week"];
      let monthInterval = [startMonth, endMonth, "month"];
      let quarterInterval = [startQuarter, endQuarter, "quarter"];

      return [todayInterval, weekInterval, monthInterval, quarterInterval];
    },
    async formatPersonKpis(data, department) {
      let result = [];

      let KPIFull = this.formatKPIsArray(data, department, "full");
      let KPIQuick = this.formatKPIsArray(data, department, "quick");
      let KPIModifications = [];

      if (department == "sellerExperience") {
        KPIModifications = this.formatKPIsArray(data, department, "mod");
        let formattedKPIMod = this.getFormattedData(KPIModifications, "Mod");
        result.push(...formattedKPIMod);
      }

      let formattedKPIFull = this.getFormattedData(KPIFull, "Full");

      let formattedKPIQuick = this.getFormattedData(KPIQuick, "Quick");

      result.push(...formattedKPIFull, ...formattedKPIQuick);

      result = result.filter(function (v) {
        return this[v.name]
          ? !Object.assign(this[v.name], v)
          : (this[v.name] = v);
      }, {});

      //map data by custom format:
      result = this.mapDataToFitFormat(result, department);
      return result;
    },
    //type - quick/full/mod/reReg
    //department - warehouse/sellerExperience
    //data - all data
    formatKPIsArray(data, department, type) {
      let result = {};
      result["quarter"] = data.quarter[department][type];
      result["month"] = data.month[department][type];
      result["week"] = data.week[department][type];
      result["today"] = data.today[department][type];

      return result;
    },

    async formatReRegistrations(data) {
      let reRegistrations = this.formatKPIsArray(
        data,
        "sellerExperience",
        "reReg"
      );

      let formattedReRegistrations = this.getFormattedData(reRegistrations, "");
      //map empty values
      formattedReRegistrations = formattedReRegistrations.map((el) => {
        return {
          name: el.name,
          today: `${el.today ? el.today : 0}`,
          week: `${el.week ? el.week : 0}`,
          month: `${el.month ? el.month : 0}`,
          quarter: `${el.quarter ? el.quarter : 0}`,
        };
      });
      return formattedReRegistrations;
    },

    mapDataToFitFormat(data, department) {
      let result = [];
      if (department == "sellerExperience") {
        result = data.map((el) => {
          let formattedObject = { name: el.name };
          formattedObject["today"] = `${el.todayFull ? el.todayFull : 0}/${
            el.todayQuick ? el.todayQuick : 0
          }/${el.todayMod ? el.todayMod : 0}`;
          formattedObject["week"] = `${el.weekFull ? el.weekFull : 0}/${
            el.weekQuick ? el.weekQuick : 0
          }/${el.weekMod ? el.weekMod : 0}`;
          formattedObject["month"] = `${el.monthFull ? el.monthFull : 0}/${
            el.monthQuick ? el.monthQuick : 0
          }/${el.monthMod ? el.monthMod : 0}`;
          formattedObject["quarter"] = `${
            el.quarterFull ? el.quarterFull : 0
          }/${el.quarterQuick ? el.quarterQuick : 0}/${
            el.quarterMod ? el.quarterMod : 0
          }`;
          return formattedObject;
        });
      } else {
        result = data.map((el) => {
          let formattedObject = { name: el.name };
          formattedObject["today"] = `${el.todayFull ? el.todayFull : 0}/${
            el.todayQuick ? el.todayQuick : 0
          }`;
          formattedObject["week"] = `${el.weekFull ? el.weekFull : 0}/${
            el.weekQuick ? el.weekQuick : 0
          }`;
          formattedObject["month"] = `${el.monthFull ? el.monthFull : 0}/${
            el.monthQuick ? el.monthQuick : 0
          }`;
          formattedObject["quarter"] = `${
            el.quarterFull ? el.quarterFull : 0
          }/${el.quarterQuick ? el.quarterQuick : 0}`;
          return formattedObject;
        });
      }

      return result;
    },

    //type - Full/Quick/ReReg
    //data - all data from KPIs
    getFormattedData(data, type) {
      let result = [];
      result = result.concat(
        this.mapByTimePeriod(data.quarter, "quarter", type)
      );
      result = result.concat(this.mapByTimePeriod(data.month, "month", type));
      result = result.concat(this.mapByTimePeriod(data.week, "week", type));
      result = result.concat(this.mapByTimePeriod(data.today, "today", type));

      //filter by name, merge objects with same name
      result = result.filter(function (v) {
        return this[v.name]
          ? !Object.assign(this[v.name], v)
          : (this[v.name] = v);
      }, {});

      return result;
    },
    //type - Full/Quick/Mod
    //data - data of current period info
    //period - today/week/month/quarter
    mapByTimePeriod(data, period, type) {
      let result = [];

      result = data.map((el) => {
        let quantity = el.quantity;
        let name = `${el.firstName} ${el.lastName}`;
        delete el["quantity"]; // Delete old key
        el[`${period}${type}`] = quantity;

        delete el["firstName"]; // Delete old key
        delete el["lastName"]; // Delete old key
        el["name"] = name;
        return el;
      });

      return result;
    },
    /*
      type - full or quick
      full index is 0, quick index is 1
    */
    formatChartKpis(data, type) {
      let finalChart = [];
      let chartHeader = [""];
      let chartDay = ["Day"];
      let chartWeek = ["Week"];
      let chartMonth = ["Month"];
      let chartQuarter = ["Quarter"];
      for (let itm of data) {
        let today = itm.today.split("/");
        let week = itm.week.split("/");
        let month = itm.month.split("/");
        let quarter = itm.quarter.split("/");
        chartHeader.push(itm.name);

        chartDay.push(parseInt(today[type]));
        chartWeek.push(parseInt(week[type]));
        chartMonth.push(parseInt(month[type]));
        chartQuarter.push(parseInt(quarter[type]));
      }
      finalChart.push(chartHeader);
      finalChart.push(chartDay);
      finalChart.push(chartWeek);
      finalChart.push(chartMonth);
      finalChart.push(chartQuarter);
      return finalChart;
    },
    /*
      full index is 0, quick index is 1
    */
    formatChartKpisCustom(data, index) {
      let finalChartKpi = [];

      let chartHeader = [""];
      let chartTotal = [""];
      for (let itm of data) {
        chartHeader.push(itm.name);
        // if (itm.modifications) {
        //   sumTotal += parseInt(itm.modifications);
        // }

        chartTotal.push(parseInt(itm.quantity.split("/")[index]));
      }
      finalChartKpi.push(chartHeader);
      finalChartKpi.push(chartTotal);

      return finalChartKpi;
    },

    async formatPersonKpisCustom(data, department) {
      let full_quick = [];
      let result = [];

      let fullKPI = data.custom[department].full;
      let quickKPI = data.custom[department].quick;
      let reRegistrations = [];
      let modifications = [];

      fullKPI = this.updatePropertyNames(fullKPI, "Full");
      quickKPI = this.updatePropertyNames(quickKPI, "Quick");

      if (department == "sellerExperience") {
        reRegistrations = data.custom[department].reReg;
        reRegistrations = this.updatePropertyNames(reRegistrations, "ReReg");
        full_quick.push(...reRegistrations);

        modifications = data.custom[department].mod;
        modifications = this.updatePropertyNames(modifications, "Mod");
        full_quick.push(...modifications);
      }

      full_quick.push(...fullKPI, ...quickKPI);

      // filter by name, merge objects with same name
      result = full_quick.filter(function (v) {
        return this[v.name]
          ? !Object.assign(this[v.name], v)
          : (this[v.name] = v);
      }, {});

      //map full and quick together
      result = result.map((el) => {
        return {
          name: el.name,
          quantity: `${el.Full ? el.Full : 0}/${el.Quick ? el.Quick : 0}`,
          reReg: `${el.ReReg ? el.ReReg : 0}`,
          modifications: `${el.Mod ? el.Mod : 0}`,
        };
      });

      return result;
    },

    updatePropertyNames(data, type) {
      let result = [];
      //map names and rename properties
      result = data.map((el) => {
        let quantity = el.quantity;
        let name = `${el.firstName} ${el.lastName}`;
        delete el["quantity"]; // Delete old key
        el[type] = quantity;

        delete el["firstName"]; // Delete old key
        delete el["lastName"]; // Delete old key
        el["name"] = name;
        return el;
      });

      return result;
    },

    // formatPersonKpis(data, department) {
    //   let fullKPI = [];
    //   let quickKPI = [];

    //   if (department in retrData) {
    //     if (retrData[department]["full"]) {
    //       fullKPI = this.getNumbers(retrData[department]["full"]);
    //       console.log("fullKPI", fullKPI);
    //     }
    //     if (retrData[department]["quick"]) {
    //       quickKPI = this.getNumbers(retrData[department]["quick"]);
    //     }
    //   }

    //   let result = [];

    //   for (let full of fullKPI) {
    //     if (!quickKPI.some((e) => e.name === full.name)) {
    //       quickKPI.push({
    //         name: full.name,
    //         today: 0,
    //         week: 0,
    //         month: 0,
    //         quarter: 0,
    //       });
    //     }
    //   }

    //   for (let quick of quickKPI) {
    //     if (!fullKPI.some((e) => e.name === quick.name)) {
    //       fullKPI.push({
    //         name: quick.name,
    //         today: 0,
    //         week: 0,
    //         month: 0,
    //         quarter: 0,
    //       });
    //     }
    //   }

    //   if (fullKPI.length != 0 && quickKPI.length != 0) {
    //     result = fullKPI.map((e) => {
    //       let temp = quickKPI.find((element) => element.name === e.name);
    //       if (temp) {
    //         e = {
    //           name: e.name,
    //           today: e.today + "/" + temp.today,
    //           week: e.week + "/" + temp.week,
    //           month: e.month + "/" + temp.month,
    //           quarter: e.quarter + "/" + temp.quarter,
    //         };
    //       }
    //       return e;
    //     });
    //   }
    //   return result;
    // },
    // formatPersonKpisCustom(data) {
    //   let result = [];

    //   let fullKPI = [];
    //   let quickKPI = [];
    //   let modificationsKPI = [];

    //   if (data.full.length > 0) {
    //     fullKPI = data.full.map((objFull) => {
    //       return { user: objFull.user, countFull: objFull.count };
    //     });
    //   }

    //   if (data.quick.length > 0) {
    //     quickKPI = data.quick.map((objQuick) => {
    //       return { user: objQuick.user, countQuick: objQuick.count };
    //     });
    //   }

    //   switch (true) {
    //     case fullKPI.length > 0 && quickKPI.length > 0:
    //       //if there are more fullKPI's or they are equal
    //       if (fullKPI.length >= quickKPI.length) {
    //         for (let i = 0; i < fullKPI.length; i++) {
    //           //search for object with same username in quickKPI
    //           let foundQ = quickKPI.find(
    //             (element) => element.user == fullKPI[i].user
    //           );
    //           if (foundQ) {
    //             result.push(Object.assign(foundQ, fullKPI[i]));
    //             //founded quickKPI item index
    //             let indexQ = quickKPI
    //               .map((x) => {
    //                 return x.user;
    //               })
    //               .indexOf(foundQ.user);
    //             //remove it from quickKPI
    //             quickKPI.splice(indexQ, 1);
    //           } else {
    //             fullKPI[i]["countQuick"] = 0;
    //             result.push(fullKPI[i]);
    //           }
    //         }
    //         //if there are some users left in quickKPI
    //         if (quickKPI.length > 0) {
    //           //add them to result array with countFull 0
    //           for (let quickItem of quickKPI) {
    //             quickItem["countFull"] = 0;
    //             result.push(quickItem);
    //           }
    //         }
    //       }
    //       //if there are more quickKPI's or they are equal
    //       else if (quickKPI.length >= fullKPI.length) {
    //         for (let j = 0; j < quickKPI.length; j++) {
    //           let foundF = fullKPI.find(
    //             (element) => element.user == quickKPI[j].user
    //           );
    //           if (foundF) {
    //             result.push(Object.assign(foundF, quickKPI[j]));
    //             //founded fullKPI item index
    //             let indexF = quickKPI
    //               .map((x) => {
    //                 return x.user;
    //               })
    //               .indexOf(foundF.user);
    //             //remove it from fullKPI
    //             fullKPI.splice(indexF, 1);
    //           } else {
    //             quickKPI[j]["countFull"] = 0;
    //             result.push(quickKPI[j]);
    //           }
    //         }
    //         //if there are some users left in fullKPI
    //         if (fullKPI.length > 0) {
    //           //add them to result array with countQuick 0
    //           for (let fullItem of fullKPI) {
    //             fullItem["countQuick"] = 0;
    //             result.push(fullItem);
    //           }
    //         }
    //       }
    //       break;
    //     case fullKPI.length > 0 && quickKPI.length == 0:
    //       result = fullKPI.map((obj) => {
    //         return { user: obj.user, countFull: obj.countFull, countQuick: 0 };
    //       });
    //       break;
    //     case fullKPI.length == 0 && quickKPI.length > 0:
    //       result = quickKPI.map((obj) => {
    //         return { user: obj.user, countFull: 0, countQuick: obj.countQuick };
    //       });
    //       break;
    //     default:
    //       result = [];
    //   }
    //   //if there are modifications object
    //   if (data.modifications != undefined) {
    //     //if there are some values in modifications object, add them to modification array
    //     if (data.modifications != 0) {
    //       modificationsKPI = data.modifications.map((obj) => {
    //         return { user: obj.user, modifications: obj.count };
    //       });
    //     }
    //     //add modification values to result array
    //     for (let user of result) {
    //       let found = modificationsKPI.find(
    //         (element) => element.user == user.user
    //       );
    //       if (found) {
    //         user["modifications"] = found.modifications;
    //       } else {
    //         user["modifications"] = 0;
    //       }
    //     }
    //     result = result.map((el) => {
    //       return {
    //         user: el.user,
    //         count: `${el.countFull}/${el.countQuick}`,
    //         modifications: el.modifications,
    //       };
    //     });
    //   } else {
    //     result = result.map((el) => {
    //       return { user: el.user, count: `${el.countFull}/${el.countQuick}` };
    //     });
    //   }
    //   return result;
    // },
    // getSellerExpKPI() {
    //   if (
    //     this.overallKpisSEStats.length == 0 ||
    //     this.modificationsKpisSE.length == 0
    //   ) {
    //     this.overallKpisSEStats = [];
    //     this.modificationsKpisSE = [];

    //     this.loadingSE = true;

    //     this.$store
    //       .dispatch("getSEKPI")
    //       .then((response) => {
    //         let stats = response.data.sellerExperience.stats;

    //         this.overallKpisSEStats = [
    //           {
    //             monthMedian: stats.monthMedian,
    //             monthAverage: stats.monthAverage,
    //             totalMonth: `${stats.totalMonthFull}/${stats.totalMonthQuick}`,
    //             totalQuarter: `${stats.totalQuarterFull}/${stats.totalQuarterQuick}`,
    //           },
    //         ];

    //         this.modificationsKpisSE.push(
    //           response.data.sellerExperience.modifications
    //         );

    //         this.personKpisSE = this.formatPersonKpis(
    //           response.data,
    //           "sellerExperience"
    //         );

    //         let reRegistrations =
    //           response.data.sellerExperience.reRegistrations;

    //         if (reRegistrations != 0) {
    //           this.personReRegistration = this.getNumbers(reRegistrations);
    //         }

    //         if (this.personKpisSE.length > 0) {
    //           this.chartDataSEFull = this.formatChartKpis(this.personKpisSE, 0);
    //           this.chartDataSEQuick = this.formatChartKpis(
    //             this.personKpisSE,
    //             1
    //           );
    //         }

    //         this.loadingSE = false;
    //       })
    //       .catch((error) => {
    //         this.loadingSE = false;
    //         console.log("error", error);
    //         this.errors.push(error);
    //       });
    //   }
    // },
    // getCustomKPI() {
    //   this.loadingCustom = true;

    //   this.KPIWarehouseStatsCustom = [];
    //   this.overallKpisSEStatsCustom = [];

    //   this.$store
    //     .dispatch("getCustomKPI", {
    //       start: this.startDate,
    //       // start: "2021-03-08",
    //       end: this.endDate,
    //     })
    //     .then((response) => {
    //       let statsW = response.data.warehouse.stats;
    //       let statsSE = response.data.sellerExperience.stats;

    //       this.KPIWarehouseStatsCustom = [
    //         {
    //           median: statsW.median,
    //           average: statsW.average,
    //           total: `${statsW.totalFull}/${statsW.totalQuick}`,
    //         },
    //       ];
    //       this.overallKpisSEStatsCustom = [
    //         {
    //           median: statsSE.median,
    //           average: statsSE.average,
    //           total: `${statsSE.totalFull}/${statsSE.totalQuick}`,
    //         },
    //       ];

    //       this.personKpisWarehouseCustom = this.formatPersonKpisCustom(
    //         response.data.warehouse
    //       );

    //       this.personKpisSECustom = this.formatPersonKpisCustom(
    //         response.data.sellerExperience
    //       );

    //       this.chartDataWarehouseCustomFull = this.formatChartKpisCustom(
    //         this.personKpisWarehouseCustom,
    //         0
    //       );

    //       this.chartDataWarehouseCustomQuick = this.formatChartKpisCustom(
    //         this.personKpisWarehouseCustom,
    //         1
    //       );

    //       this.chartDataSECustomFull = this.formatChartKpisCustom(
    //         this.personKpisSECustom,
    //         0
    //       );
    //       this.chartDataSECustomQuick = this.formatChartKpisCustom(
    //         this.personKpisSECustom,
    //         1
    //       );

    //       this.loadingCustom = false;
    //     })
    //     .catch((error) => {
    //       this.loadingCustom = false;
    //       console.log("error", error);
    //       this.errors.push(error);
    //     });
    // },
    // getWarehouseKPI() {
    //   if (this.overallKpisWarehouse.length == 0) {
    //     this.loadingWarehouse = true;
    //     this.overallKpisWarehouse = [];

    //     this.$store
    //       .dispatch("getWarehouseKPI")
    //       .then((response) => {
    //         let stats = response.data.warehouse.stats;
    //         this.overallKpisWarehouse = [
    //           {
    //             monthMedian: stats.monthMedian,
    //             monthAverage: stats.monthAverage,
    //             totalMonth: `${stats.totalMonthFull}/${stats.totalMonthQuick}`,
    //             totalQuarter: `${stats.totalQuarterFull}/${stats.totalQuarterQuick}`,
    //           },
    //         ];

    //         this.personKpisWarehouse = this.formatPersonKpis(
    //           response.data,
    //           "warehouse"
    //         );

    //         if (this.personKpisWarehouse.length > 0) {
    //           this.chartDataWarehouseFull = this.formatChartKpis(
    //             this.personKpisWarehouse,
    //             0
    //           );
    //           this.chartDataWarehouseQuick = this.formatChartKpis(
    //             this.personKpisWarehouse,
    //             1
    //           );
    //         }

    //         this.loadingWarehouse = false;
    //       })
    //       .catch((error) => {
    //         this.loadingWarehouse = false;
    //         console.log("error", error);
    //         this.errors.push(error);
    //       });
    //   }
    // },
    // getNumbers(entries) {
    //   let kpi = [];
    //   let filteredKeys = [];
    //   for (const [key, value] of Object.entries(entries)) {
    //     if (typeof value === "object") {
    //       for (let val of value) {
    //         let obj = {};
    //         const found = kpi.some((el) => el.name === val["user"]);
    //         if (found) {
    //           obj = kpi.find((el) => el.name === val["user"]);
    //         } else {
    //           kpi.push({
    //             name: val["user"],
    //             today: 0,
    //             week: 0,
    //             month: 0,
    //             quarter: 0,
    //           });
    //           obj = kpi.find((el) => el.name === val["user"]);
    //         }
    //         obj[key] = val["count"];
    //       }
    //     } else {
    //       filteredKeys.push(key);
    //     }
    //   }
    //   if (kpi.length != 0 && filteredKeys.length != 0) {
    //     for (let key of filteredKeys) {
    //       kpi.forEach((el) => (el[key] = 0));
    //     }
    //   }
    //   return kpi;
    // },
  },
  mounted() {
    this.getData();
  },
};
</script>
